<template>
    <v-app-bar :elevation="0" class="header">
        <a
            v-if="skipNavHref"
            tabindex="0"
            :aria-label="$t('본문 바로가기')"
            role="link"
            :href="skipNavHref"
            class="skip-navigation"
        >
            {{ $t("본문 바로가기") }}
        </a>

        <v-toolbar-title class="logo">
            <!-- 고객 지원 사이트로 이동 -->
            <router-link to="/" class="link">
                <img alt="Dot Inc." src="../../assets/logo.png"/>
            </router-link>
            <!-- 고객 지원 사이트로 이동 -->
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <btn-menu></btn-menu>
        <!-- <v-spacer></v-spacer> -->
        <!-- 메인 메뉴 버튼 -->
        <!-- <btn-menu></btn-menu> -->
        <!-- /메인 메뉴 버튼 -->
        <v-spacer></v-spacer>
        <btn-login></btn-login>
        <btn-lang-change></btn-lang-change>
    </v-app-bar>
</template>

<script setup>
import BtnMenu from "@/components/header/MenuBtn.vue"
import BtnLangChange from "@/components/header/LangChangeBtn.vue"
import BtnLogin from "@/components/header/LoginBtn.vue"

import { useI18n } from "vue-i18n"
import { onMounted, ref, watch } from "vue"
import { useRoute } from "vue-router"

const i18n = useI18n()
const $t = i18n.t
const route = useRoute()

const skipNavHref = ref(null)

const onChangeRouter = () => {
    switch (route.path) {
        case "/notice":
            skipNavHref.value = "#notice-title"
            break
        case "/update/firmware/connect":
            skipNavHref.value = "#update-firmware-title"
            break
        case "/faq":
            skipNavHref.value = "#faq-title"
            break
    }
}

watch(
    () => route.path,
    () => {
        onChangeRouter()
    }
)

onMounted(() => {
    onChangeRouter()
})


</script>

<style scoped>
.header {
    padding: 10px 2%;
    border-bottom: 1px solid #d9d9d9;
    height: 84px;
}

.logo {
    flex: none;
    margin: 0;
}

.skip-navigation {
    position: absolute;
    top: 0;
    left: 0;
    padding: .8rem 1.6rem;
    background-color: #000;
    font-size: 1.6rem;
    color: #fff;
    transform: translateY(-101%);
}

.skip-navigation:hover,
.skip-navigation:focus {
    transform: translateY(0);
}

</style>
